<div class="breadcrumb-area">
	<h1>Recibir Órdenes de Compra</h1>
</div>
<div class="container-fluid">
    <div class="row g-3">
        <!-- Lista de órdenes -->
        <div class="col-12 col-lg-4">
            <div class="card h-100 shadow-sm">
                <div class="d-flex flex-row flex-wrap justify-content-end gap-1">
                    <div>
                        <button class="mb-1 btn btn-sm" 
                        [class.btn-success]="showAssociated" 
                        [class.btn-outline-secondary]="!showAssociated"
                        (click)="toggleShowAssociated(true)">Asociadas</button>
                    </div>
                    <div>
                        <button class="mb-1 btn btn-sm" 
                        [class.btn-success]="!showAssociated" 
                        [class.btn-outline-secondary]="showAssociated"
                        (click)="toggleShowAssociated(false)">No Asociadas</button>
                    </div>
                </div>
            <div class="card-header">
                <div class="d-flex flex-wrap gap-2 align-items-center justify-content-between">
                <div class="fw-semibold">Órdenes</div>

                <!-- Filtro por número de orden -->
                <div class="input-group" style="max-width: 320px;">
                    <input
                    type="text"
                    class="form-control"
                    placeholder="Buscar por # de orden..."
                    [(ngModel)]="orderNumberQuery"
                    (ngModelChange)="applyFilterAndReset()"
                    />
                    <button class="btn btn-outline-secondary" type="button" (click)="clearOrderFilter()">
                    Limpiar
                    </button>
                </div>
                </div>
            </div>

            <div class="card-body p-0">
                <div *ngIf="loadingOrders" class="p-3 text-center">Cargando órdenes…</div>

                <table class="table table-sm mb-0 align-middle" *ngIf="!loadingOrders">
                <thead class="table-light">
                    <tr>
                    <th style="width: 90px;">#</th>
                    <th>Proveedor</th>
                    <th>Creación</th>
                    <th style="width: 90px;"></th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let o of allOrders; trackBy: trackByOrder">
                    <td>{{ o.number }}</td>
                    <td>
                        <div class="small fw-semibold">{{ o.providerData?.name || '-' }}</div>
                        <div class="small text-muted">NIT: {{ o.providerData?.nit || '-' }}</div>
                    </td>
                    <td class="small">
                        {{ o.creationDate ? (o.creationDate | date:'shortDate') : '-' }}
                    </td>
                    <td class="text-end">
                        <button class="btn btn-sm btn-outline-secondary" (click)="selectOrder(o)">Ver</button>
                    </td>
                    </tr>

                    <tr *ngIf="pagination.total.length === 0">
                    <td colspan="4" class="text-center py-3 text-muted">Sin resultados</td>
                    </tr>
                </tbody>
                </table>
            </div>
            <app-pagination-custom
                [elements]="pagination"
                (changed)="onPageChanged($event)"
                ></app-pagination-custom>
            </div>
        </div>

        <!-- Detalle + Form de transporte -->
        <div class="col-12 col-lg-8" *ngIf="selectedOrder">
        <div class="card shadow-sm">
            <div class="card-header">
            <div class="d-flex flex-wrap justify-content-between align-items-center gap-2">
                <div>
                <div class="fw-semibold">Orden #{{ selectedOrder.number }}</div>
                <div class="small text-muted">
                    Proveedor: <span class="fw-semibold">{{ selectedOrder.providerData?.name }}</span>
                    &nbsp;·&nbsp; Creación: {{ epochToDate(selectedOrder.creationDate) }}
                    &nbsp;·&nbsp; Entrega: {{ epochToDate(selectedOrder.deliveryDate) }}
                </div>
                </div>
                <div class="d-flex gap-2">
                <button class="btn btn-sm btn-outline-success" (click)="markAllOk()" [disabled]="loadingDetails || detailsVm.length===0">
                    <i class="fa fa-check-double"></i> Marcar todo “Recibido”
                </button>
                <button class="btn btn-sm btn-primary"
                        (click)="saveReceived()"
                        [disabled]="saving || !allRowsValid() || !transportFormValid() || loadingDetails">
                    <i class="fa fa-save"></i> Crear recepción
                </button>
                </div>
            </div>
            </div>

            <!-- Form transporte/piloto -->
            <div class="card-body border-bottom">
            <div class="row g-3">
                <div class="col-md-6">
                <label class="form-label">Nombre del Piloto</label>
                <input class="form-control" [(ngModel)]="pilot" placeholder="Ej. Juan Pérez">
                </div>
                <div class="col-md-6">
                <label class="form-label">Licencia del Piloto</label>
                <input class="form-control" [(ngModel)]="pilotLicense" placeholder="Ej. B-123456">
                </div>
                <div class="col-md-4">
                <label class="form-label">Placa del cabezal</label>
                <input class="form-control" [(ngModel)]="plateCar" placeholder="Ej. P123ABC">
                </div>
                <div class="col-md-4">
                <label class="form-label">Placa de la plataforma</label>
                <input class="form-control" [(ngModel)]="platePlatform" placeholder="Ej. C456DEF">
                </div>
                <div class="col-md-4">
                <label class="form-label">No. de Contenedor</label>
                <input class="form-control" [(ngModel)]="container" placeholder="Ej. ABCD1234567">
                <div class="form-text">Se usa también para asociar pagos por contenedor.</div>
                </div>
                <div class="col-md-12">
                    <!-- Filtro por producto -->
                    <label class="form-label">Buscar producto por nombre</label>
                    <input
                        type="text"
                        class="form-control mb-3"
                        placeholder="Ej. Aspirina o 1234"
                        [(ngModel)]="productQuery"
                        (ngModelChange)="applyProductFilter()"
                    />
                </div>
            </div>
            </div>

            <!-- Tabla de detalle -->
            <div class="card-body p-0">
            <div *ngIf="loadingDetails" class="p-3 text-center">Cargando detalle…</div>
            <div class="table-responsive" *ngIf="!loadingDetails">
                
                <table class="table table-sm align-middle mb-0">
                <thead class="table-light">
                    <tr>
                    <th>Producto</th>
                    <th class="text-center">Solicitado</th>
                    <th class="text-center">Falta por Recibir</th>
                    <th class="text-center">Acción</th>
                    <th style="width:220px;">Faltaron · ¿Cuántos llegaron?</th>
                    <th class="text-center">Diferencia</th>
                    <th class="">Bodega</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let r of filteredDetails; trackBy: trackByDetail">
                    <td>
                        <div class="fw-semibold">{{ r.productData?.name }}</div>
                        <div class="small text-muted">Código: {{ r.productData?.code }}</div>
                    </td>
                    <td class="text-center">{{ r.quantity }}</td>
                    <td class="text-center">{{ (r.quantity - r.toReceive) }}</td>
                    <td class="text-center">
                        <div class="btn-group" role="group">
                        <button type="button"
                                class="btn btn-success btn-sm"
                                [class.opacity-50]="r.type && r.type !== 'ok'"
                                (click)="markOk(r)"
                                title="Recibidos">
                            <i class="fa fa-circle-check"></i>
                        </button>
                        <button type="button"
                                class="btn btn-danger btn-sm"
                                [class.opacity-50]="r.type && r.type !== 'miss'"
                                (click)="markMiss(r)"
                                title="Faltaron">
                            <i class="fa fa-circle-xmark"></i>
                        </button>
                        </div>
                    </td>
                    <td>
                        <input type="number"
                            class="form-control text-center"
                            [readonly]="r.type !== 'miss'"
                            [min]="0"
                            [max]="r.quantity"
                            [ngModel]="r.userQuantity"
                            (ngModelChange)="r.userQuantity = $event">
                        <div class="form-text" *ngIf="r.type==='miss'">
                        Debe estar entre 0 y {{ r.quantity - r.toReceive }}
                        </div>
                    </td>
                    <td class="text-center">
                        <span 
                        [class.text-danger]="(r.userQuantity < r.quantity)"
                        [class.text-success]="(r.userQuantity > r.quantity)"
                        [class.text-primary]="(r.userQuantity == r.quantity)">
                            <span *ngIf="(r.userQuantity > (r.quantity - r.toReceive))">
                                {{ (difference(r)>0)? '+'+difference(r) : difference(r) }}
                            </span>
                            <span *ngIf="(r.userQuantity < (r.quantity - r.toReceive))">
                                {{ '-'+difference(r)}}
                            </span>
                            <span *ngIf="(r.userQuantity == (r.quantity - r.toReceive))">
                                {{ difference(r)}}
                            </span>
                        </span>
                        <div class="small text-muted" *ngIf="r.type">({{ r.type==='ok' ? 'OK' : 'MISS' }})</div>
                    </td>
                    <td class="">
                        <div class="fw-semibold">{{ r.warehouseData.name }}</div>
                        <div class="small text-muted">Código: {{ r.warehouseData.code }}</div>
                    </td>
                    </tr>
                    <tr *ngIf="detailsVm.length === 0">
                    <td colspan="6" class="text-center py-3 text-muted">Sin detalle</td>
                    </tr>
                </tbody>
                <tfoot *ngIf="detailsVm.length > 0" class="table-light">
                    <tr>
                    <td class="fw-semibold">Totales</td>
                    <td class="text-center">—</td>
                    <td class="text-center">—</td>
                    <td class="text-center">
                        <span class="badge bg-success">OK: {{ okCount }}</span>
                        <span class="badge bg-danger ms-2">MISS: {{ missCount }}</span>
                    </td>
                    <td>—</td>
                    <td class="text-center fw-semibold">
                        Faltantes totales: {{ totalMissingUnits }}
                    </td>
                    <td>—</td>
                    </tr>
                </tfoot>
                </table>
            </div>
            </div>

            <div class="card-footer d-flex flex-wrap justify-content-between align-items-center gap-2">
            <div class="small text-muted">
                Revisados: {{ decidedCount }}/{{ detailsVm.length }}
            </div>
            <button class="btn btn-primary"
                    (click)="saveReceived()"
                    [disabled]="saving || !allRowsValid() || !transportFormValid() || loadingDetails">
                <i class="fa fa-save"></i> Crear recepción
            </button>
            </div>
        </div>
        </div>

        <div class="col-12 col-lg-8" *ngIf="!selectedOrder">
        <div class="card h-100 shadow-sm">
            <div class="card-body d-flex align-items-center justify-content-center text-muted">
            Selecciona una orden para continuar
            </div>
        </div>
        </div>
    </div>
</div>
